<template>
  <div class="container mx-auto profile">
    <h1>Profile</h1>
    <h2 v-if="ordersAreFetched === true" class="bg-white w-full p-4" 
      style="color: #414066;
            white-space: nowrap; 
            overflow: hidden; 
            text-overflow: ellipsis; 
            max-width: 100%;"
    >Orders of <strong>{{ customerAcc }}</strong></h2>

    <h2 v-if="customerAcc === null || ordersAreFetched === false" class="bg-white w-full p-4" style="color: #414066;">Sign in or reload page to see your orders</h2>

    <div v-if="customerAcc && orders.length < 1" class="bg-white w-full mt-4 p-4 items-left" style="color: #414066;">No orders found. Try reloading or signing in.</div>

    <div v-if="customerAcc && orders.length > 0">
      <div v-for="(order, index) in orders" :key="index" class="bg-white w-full mt-4 p-4 items-left" 
        style="color: #414066;   
              white-space: nowrap; 
              overflow: hidden; 
              text-overflow: ellipsis; 
              max-width: 100%;"
      >
        <div class="flex items-start w-full">
          <div class="img-wrapper desktop">
            <img :src="this.uploadsUrl + '/' + order.image_name"/>
          </div>
          <table class="order-table ml-8">
            <tbody>
              <tr class="row">
                <td class="label">Order Nr.</td>
                <td class="value"><strong>{{ order.order_nr }}</strong></td>
              </tr>
              <tr>
                <td class="label">Tx hash</td>
                <td class="value">
                  <a v-if="order.tx_hash" target="_blank" :href="'https://' + this.network + '.xrpl.org/transactions/' + order.tx_hash">
                    {{ order.tx_hash.substring(0, 20) }}...
                  </a>
                  <span v-else></span>
                </td>
              </tr>
              <tr>
                <td class="label">Size</td>
                <td class="value"><strong>{{ order.px_horizontal / 10 }}x{{ order.px_vertical / 10 }} squares</strong> ({{ order.px_horizontal }}x{{ order.px_vertical }}px)</td>
              </tr>
              <tr>
                <td class="label">Coordinates</td>
                <td class="value"><strong>{{ order.coords_x_left }}, {{ order.coords_y_top }}, {{ order.coords_x_right }}, {{ order.coords_y_bottom }}</strong></td>
              </tr>
              <tr>
                <td class="label">Url link</td>
                <td class="value"><strong>{{ order.url }}</strong></td>
              </tr>
              <tr>
                <td class="label">Display text</td>
                <td class="value"><strong>{{ order.display_text }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="w-full img-btn-wrapper">
          <div class="img-wrapper mobile">
            <img :src="this.uploadsUrl + '/' + order.image_name" />
          </div>
          <div class="flex justify-end w-full pt-4 edit-btn-wrapper">
            <button @click="handleEditClick(
              order.id,
              order.number,
              order.url,
              order.display_text,
              order.twitter,
              order.email,
              order.discord,
              order.px_horizontal,
              order.px_vertical
              )" class="btn btn-light btn-form">
              Edit <img style="width: 30px; margin-left: 10px;" src="../assets/images/edit-icon.svg"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <teleport to="#app">
    <transition name="modal-fade">
    <div v-if="this.letsEditOrder" class="fixed top-0 left-0 w-full h-full z-900 shadow-md p-4 bg-black bg-opacity-70 modal-bg" @click.self="cancelOrderUpdate">
      <div class="sticky top-5 flex items-start justify-center min-h-screen mt-24 text-center">
        <div ref="target" class="bg-white p-2 shadow-xl w-full max-w-md modal-content" role="dialog" aria-modal="true">
          <!-- Close button in the top-right corner -->
          <button 
            @click="cancelOrderUpdate" 
            class="top-2 right-2 text-gray-600 hover:text-gray-900 btn-close"
            aria-label="X"
          >
            <img src="../assets/images/icon-close.png" alt="X" width="40" height="40">
          </button>
          <div class="modal-header">
            <h1 class="text-xl font-bold top-2">Update order {{ actionOrder.number }}</h1>
            <p>{{ actionOrder.px_horizontal / 10 }}x{{ actionOrder.px_vertical / 10 }} squares ({{ actionOrder.px_horizontal || null }}x{{ actionOrder.px_vertical || null }} px)</p>
            <h1 class="text-xl font-bold top-2">Price: {{ actionPrice }} {{ actionCurrency }}</h1>
          </div>

          <!-- Progress Bar -->
          <div class="w-full progress-wrapper">
            <div 
              class="progress-bar"
              :style="{ width: progressPercentage + '%' }"
            >
              <p :style="{ paddingRight: (Math.max(13,(100 - progressPercentage)) * 0.6 ) + '%' }">{{ displayStep }} / 4</p>
            </div>
          </div>
   
          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 1" class="step step-1">
            <h2 class="text-xl mb-4">Upload your wall image</h2>

            <div v-if="!this.actionOrder.image || !this.imgUrl" class="image-select flex items-center justify-center">
                <a class="btn btn-outline-light" @click.prevent="launchChooseFile">Upload image</a>
            </div>

            <div v-if="this.actionOrder.image && this.imgUrl" class="image-wrapper flex items-center justify-center">
              <button 
                @click="deleteImage" 
                class="text-gray-600 hover:text-gray-900 btn-close btn-remove"
                aria-label="X"
              >
                Remove upload
              </button>
              <img :src="this.imgUrl" class="preview"/>
            </div>
            <input 
              ref="imageInput" 
              type="file" 
              name="image" 
              class="image" 
              accept="image/*"
              single 
              @change="handleImageUpload"
            />
            <div class="flex justify-center mt-4 step-btns">
              <button @click="forwardStep" class="btn btn-light btn-multi">
                <span v-if="!this.actionOrder.image || !this.imgUrl">Skip</span>
                <span v-if="this.actionOrder.image && this.imgUrl">Next</span>
              </button>
            </div>
          </div>
          </transition>

          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 2">
            <h2 class="text-xl mb-4">Change your spot info</h2>
            <div class="form-group-wrapper"> 
              <div class="form-group">
                <!--<label for="displayText">Text others will see when hovering your spot</label>-->
                <input 
                  id="displayText"
                  ref="displayTextInput"
                  type="text" 
                  v-model="actionOrder.display_text" 
                  :maxlength="200" 
                  placeholder="Enter a display text of your spot"
                />
              </div>
              <div class="form-group">
                <!--<label for="url">Url that gets open when pressing your spot</label>-->
                <input 
                  id="url"
                  type="url" 
                  ref="urlInput"
                  v-model="actionOrder.url" 
                  placeholder="Enter a URL for your spot"
                  :pattern="urlPattern"
                />
              </div>
              <div class="form-group">
                <!--<label for="url">Url that gets open when pressing your spot</label>-->
                <input 
                  id="affiliate"
                  ref="affiliateInput"
                  type="text" 
                  v-model="actionOrder.affiliate_code" 
                  placeholder="Enter affiliate code if available"
                />
              </div>
            </div>
            <div class="flex justify-center mt-4 step-btns">
              <button @click="prevStep" class="btn btn-secondary mr-8">Back</button>
              <button @click="forwardStep" class="btn btn-light btn-multi ml-8">Next</button>
            </div>
          </div>
          </transition>

          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 3">
            <h2 class="text-xl mb-4" >Change your contacts</h2>
            <div class="form-group-wrapper"> 
              <div class="form-group">
                <font-awesome-icon :icon="['fas', 'envelope']" style="color: #3185fc;" class="icon-for-input"/>
                <input 
                  id="email"
                  ref="emailInput"
                  type="email" 
                  v-model="actionOrder.email" 
                  placeholder="Enter e-mail"
                  class="input-with-icon"
                />
              </div>
              <div class="form-group">
                <font-awesome-icon :icon="['fab', 'x-twitter']" style="color: #3185fc;" class="icon-for-input"/>
                <input 
                  id="x"
                  ref="xInput"
                  type="text" 
                  v-model="actionOrder.twitter" 
                  placeholder="Enter X handle"
                  class="input-with-icon"
                />
              </div>
              <div class="form-group">
                <font-awesome-icon :icon="['fab', 'discord']" style="color: #3185fc;" class="icon-for-input"/>
                <input 
                  id="discord"
                  ref="discordInput"
                  type="text" 
                  v-model="actionOrder.discord" 
                  placeholder="Enter Discord"
                  class="input-with-icon"
                />
              </div>
            </div>
            <div class="flex justify-center mt-4 step-btns">
              <button @click="prevStep" class="btn btn-secondary mr-4">Back</button>
              <button class="btn btn-light btn-multi ml-8"  @click="authorize" ref="connectWalletButton" v-if="customerAcc == null">Sign in <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
              <button class="btn btn-light btn-multi ml-8"  @click="pay" ref="disconnectWalletSpan" v-if="customerAcc !== null"> Pay <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
            </div>
          </div>
          </transition>

          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 4">

            <h2 v-if="this.orderUpdated == false" class="text-xl mb-4">Pay with Xaman</h2>
            <h2 v-if="this.orderUpdated == true" class="text-xl mb-4">Congratulations!</h2>

            <div v-if="this.waitingForPut == false && this.orderUpdated == false" class="payment-info-wrapper mt-2 flex justify-center items-center flex-col w-full px-10"> 
              <p v-if="this.paymentNotSigned == false" class="mb-3" style="color: gray;">You should receive a notification in Xaman App</p>
              <img class="xaman-icon" :src="this.paymentInfo.qr" width="50%"/>
              <p v-if="!this.paymentInfo.qr">No payment QR code available.</p>
              <p v-if="this.paymentInfo.url">If no notification, scan this QR code or <br><a target="_blank" v-bind:href="this.paymentInfo.url"> press on this link.</a></p>
              <p v-if="!this.paymentInfo.url">No payment link available.</p>
              <p v-if="!this.paymentInfo.qr && !this.paymentInfo.url">Try pressing Pay button.</p>
              <div v-if="this.paymentNotSigned == false" class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>

            <div v-if="this.waitingForPut == true" class="submit-info-wrapper mt-2 flex justify-center items-center flex-col w-full px-10"> 
              <p class="mb-3" style="color: gray;">Updating your order. Please wait...</p>
              <div class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>

            <div v-if="this.orderUpdated == true" class="cuccess-wrapper mt-2 flex justify-center items-center flex-col w-full px-10"> 
              <p class="mb-3">Your order has been updated!</p>
              <p class="mb-3">Order number: {{ actionOrder.number }}<br>
                Tx hash: <a target="_blank" v-bind:href="'https://'+ this.network + '.xrpl.org/transactions/' + actionOrder.tx_hash">{{ actionOrder.tx_hash.substring(0,8) }}...</a><br>
              </p>
              <img class="xrp-astronout" src="../assets/images/xrp-astronout-on-planet.png" style="width: 50%;"/>

            </div>

            <div class="flex justify-center mt-4 step-btns">
              <button @click="prevStep" class="btn btn-secondary mr-4" v-if="this.orderUpdated == false">Back</button>
              <button class="btn btn-light btn-multi ml-8"  @click="authorize" ref="connectWalletButton" v-if="customerAcc == null && this.orderUpdated == false">Sign in <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
              <button class="btn btn-light btn-multi ml-8"  @click="pay" ref="disconnectWalletSpan" v-if="customerAcc !== null && this.paymentNotSigned == true && this.orderUpdated == false">Pay <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
            </div>
          </div>
          </transition>
        </div>
      </div>
    </div>
    </transition>
  </teleport>
</template>

<script>
import axios from 'axios';
import { toast } from 'vue3-toastify';
import { ref } from 'vue';

const show = ref(true)
show.value = true

export default {
  name: 'PixelGrid',
  data () {
    return {
      network: process.env.VUE_APP_NETWORK,
      uploadsUrl: process.env.VUE_APP_API_IMAGE,
      actionPrice: process.env.VUE_APP_MOD_PRICE,
      actionCurrency:process.env.VUE_APP_MOD_CURRENCY,
      letsEditOrder: false,
      currentStep: 1,  // Tracks the current step
      nextStep: 2,  // Stores the next step temporarily
      displayStep: 1, // Stores step for .progress-bar
      translateX: 0,
      translateY: 0,
      imgUrl: null,
      updateTx: null,
      orders: [],
      actionOrder: { 
        id: null,
        number: null,
        amount: this.actionPrice,
        currency: this.actionCurrency,
        tx_hash: null,
        image: null,      
        url: null,
        display_text: null,
        email: null,
        twitter: null,
        discord: null,
        affiliate_code: null,
      },
      paymentInfo: {
        url: null,
        qr: null,
        show: false
      },
      paymentNotSigned: false,
      waitingForPut: false,
      orderUpdated: false,
    }
  },
  props: {
    customerAcc: String ,
    authorize: Function,
    isValidUrl: Function,
    isValidXRPAddress: Function,
    hexEncode: Function,
    hexDecode: Function,
    urlPattern: String,
  },
  watch: {
    // Watch for changes in the customerAcc prop
    customerAcc() {
      // Call a method when customerAcc changes
      this.tryFetchingOrders()
    },
    'actionOrder.url'(newValue) {
      this.actionOrder.url = newValue
    },
    'actionOrder.display_text'(newValue) {
      this.actionOrder.display_text = newValue
    },
    'actionOrder.affiliate_code'(newValue) {
      this.actionOrder.affiliate_code = newValue
    },
    'actionOrder.twitter'(newValue) {
      this.actionOrder.twitter = newValue
    },
    'actionOrder.discord'(newValue) {
      this.actionOrder.discord = newValue
    },
    'actionOrder.email'(newValue) {
      this.actionOrder.email = newValue
    },
  },
  computed: {
    imageStyle () {
      return {
        transform: `scale(${this.scale}) translate(${this.translateX}px, ${this.translateY}px)`,
        transition: this.isPanning ? 'none' : 'transform 0.2s ease'
      }
    },
    progressPercentage() {
      return (this.displayStep / 4) * 100;
    }
  },
  methods: {
    tryFetchingOrders() {
      console.log('this.customerAcc=' + this.customerAcc)
      if(this.customerAcc === null) {
        toast.warning('Sign in with a valid XRPL address to display your orders.', { icon: false, timeout: 200000});
      } else {
        this.fetchMyOrders()
      }
    },
    // Fetch orders from the backend
    async fetchMyOrders() {
      try {
        const response = await axios.get(process.env.VUE_APP_API_PROFILE_URL + '/' +this.customerAcc);
        if(response.status === 200) {
            this.ordersAreFetched = true;
            this.orders = response.data;
        } else {
          this.ordersAreFetched = false;
          toast.error('Failed to get your orders.\nTry reloading.', { icon: false, })
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleEditClick(id, number, url, display_text, twitter, email, discord, px_horizontal, px_vertical) {
      this.currentStep = 1

      this.actionOrder.id = id
      this.actionOrder.number = number
      this.actionOrder.url = url
      this.actionOrder.display_text = display_text
      this.actionOrder.twitter = twitter
      this.actionOrder.email = email
      this.actionOrder.discord = discord
      this.actionOrder.px_horizontal = px_horizontal
      this.actionOrder.px_vertical = px_vertical

      this.letsEditOrder = true

      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    forwardStep() {
      this.displayStep = this.currentStep

      if (this.currentStep === 2) {

        if(this.actionOrder.url !== null && !this.isValidUrl(this.actionOrder.url)) {
        toast.warning('Invalid url.\nYou should fix this.', { icon: false, });

        }

      } else if(this.currentStep > 3) {
        return;
      }
      
      this.changeStep(this.currentStep + 1)
    },
    prevStep() {
      if(this.currentStep == 4) {
        this.paymentInfo.url = null,
        this.paymentInfo.qr = null,
        this.paymentNotSigned = false
      }

      this.displayStep = this.currentStep
      if (this.currentStep > 1) this.changeStep(this.currentStep - 1)
    },
    changeStep(step) {
      this.nextStep = step;  // Store the next step
      this.currentStep = null;  // Trigger slide-out first
    },
    handleAfterLeave() {
      this.currentStep = this.nextStep;  // Perform slide-in after slide-out completes
      this.displayStep = this.currentStep
    },
    cancelOrderUpdate() {
      this.letsEditOrder = false
      this.actionOrder.coords_x_left = null
      this.actionOrder.coords_y_top = null
      this.actionOrder.coords_x_right = null
      this.actionOrder.coords_y_bottom = null
      this.actionOrder.client_address = null
      this.actionOrder.amount = null
      this.actionOrder.px_horizontal = null
      this.actionOrder.px_vertical = null
      this.actionOrder.tx_hash = null
      this.actionOrder.image = null
      this.step = 1
      this.nextStep = 2
      this.paymentInfo.url = null
      this.paymentInfo.qr = null
      this.paymentNotSigned = false
      this.orderUpdated = false
      this.waitingForPut = false
    },
    launchChooseFile() {
      this.$refs.imageInput.click();
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      
      if (!file) {
        toast.error('No image seleted.\nTry again.', { icon: false, });
        return;
      }

      // Validate file type (only allow images)
      if (!file.type.startsWith('image/')) {
        toast.error('Only image files are allowed.\nTry again.', { icon: false, });
        this.actionOrder.image = null;
        this.imgUrl = null;
        return;
      }

      // Validate file size (max 5 MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('Image is too large.\n5 MB are allowed.', { icon: false, });
        this.actionOrder.image = null;
        this.imgUrl = null;
        return;
      }

      this.imgUrl = URL.createObjectURL(file);
      this.actionOrder.image = file;
    },
    deleteImage() {
      this.actionOrder.image = null,
      this.imgUrl = null,
      this.$refs.imageInput.value = "";
    },
    // Create order payload for signing
    async pay() {
      if(!this.customerAcc || !this.isValidXRPAddress(this.customerAcc)){
        toast.error('Your XRPL address format is incorrect.\nTry signing out and in again.', { icon: false, });
        return;
      }

      this.forwardStep();

      this.actionOrder.client_address = this.customerAcc;
      const destination = process.env.VUE_APP_SELLER_XRPL_ADDRESS;

      window.xumm.payload.createAndSubscribe(
        {
          TransactionType: 'Payment',
          Destination: destination,
          Amount: String(this.actionPrice * 1000000), // one million drops, 1 XRP
          //Amount: {
          //  currency: "7842414E4B000000000000000000000000000000", // HEX-encoded xBANK
          //  value: this.actionPrice,          // Amount of MYTOKEN to transfer
          //  issuer: process.env.VUE_APP_XBANK_ISSUER // Issuer's account
          //},
          Memos: [
            {
              Memo: {
                MemoData: this.hexEncode('number:' + this.actionOrder.number),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('image_name:' + this.actionOrder.image?.name || null),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('url:' + (this.actionOrder.url ? this.actionOrder.url : null)),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('display_text:' + (this.actionOrder.display_text ? this.actionOrder.display_text : null)),
              },
            }           
          ],
        },
        (eventMessage) => {
          console.log(eventMessage)
          if ('opened' in eventMessage.data && eventMessage.data.opened == true) {
            // Xaman app notification was opened
            toast.info('Payment opened in Xaman.\nNext step is to sign it.', { icon: false, });
          }

          if ('signed' in eventMessage.data && eventMessage.data.signed === false) {
            // Handle signed payload
            toast.error('Payment was not signed.\nTry again.', { icon: false, });
            this.paymentNotSigned = true
            this.paymentInfo.url = null
            this.paymentInfo.qr = null

          } else if('signed' in eventMessage.data && eventMessage.data.signed === true) {

            this.paymentNotSigned = false
            toast.success('Payment signed in Xaman.\nWait for confirmation info.', { icon: false, });

            if(!eventMessage.data.txid) {
              toast.error('Could not get Transaction ID.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload || !eventMessage.payload.application) {
              toast.error('Transaction payload empty.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.application.uuidv4 || eventMessage.payload.application.uuidv4 != process.env.VUE_APP_XAMAN_API_KEY) {
              toast.error('Transaction was signed by another app.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.payload.tx_destination || eventMessage.payload.payload.tx_destination != process.env.VUE_APP_SELLER_XRPL_ADDRESS) {
              toast.error('Payment sent to incorrect address.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.payload.computed) {
              toast.error('Could not resolve payment content from transaction.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.payload.computed.Memos || 
            eventMessage.payload.payload.computed.Memos.length < 1) {
              toast.error('Could not resolve order details from transaction.\nCheck your transaction and profile.', { icon: false, });

            } else {
              // All good, update order with Tx data
              this.actionOrder.client_address = eventMessage.payload.payload.request_json.Account
              //this.actionOrder.amount = eventMessage.payload.payload.request_json.Amount------------------------
              this.actionOrder.tx_hash = eventMessage.data.txid

              eventMessage.payload.payload.computed.Memos.forEach(memo => {
                // Remove the surrounding quotes
                const cleanedStr = memo.Memo.MemoData.replace(/^"|"$/g, '');
                // Split the string by the colon ':'
                const parts = cleanedStr.split(':');
                // Set key and value
                if(parts[0] != 'url') {
                  this.actionOrder[parts[0]] = parts[1];
                }
              });

              this.putOrder()
              
            }
          }
        }
      )
      .then(({ created }) => {
        this.paymentInfo.url = created.next.always;
        this.paymentInfo.qr = created.refs.qr_png;
      })
      
    },
    async putOrder() {
      this.waitingForPut = true;
      try {
        // Create FormData object
        const formData = new FormData();
        formData.append('id', this.actionOrder.id);
        formData.append('number', this.actionOrder.number);
        formData.append('image', this.actionOrder.image);
        formData.append('url', this.actionOrder.url);
        formData.append('display_text', this.actionOrder.display_text);
        formData.append('affiliate_code', this.actionOrder.affiliate_code);
        formData.append('tx_hash', this.actionOrder.tx_hash);
        formData.append('email', this.actionOrder.email);
        formData.append('twitter', this.actionOrder.twitter);
        formData.append('discord', this.actionOrder.discord);

        // Make the POST request with FormData
        const response = await axios.put(process.env.VUE_APP_API_URL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data', // Ensure the request is multipart
          },
        });

        // Check if the response is successful
        if (response.data.success) {
          console.log('response=' + JSON.stringify(response));
          this.tryFetchingOrders()
          this.paymentNotSigned = false;
          this.waitingForPut = false;
          this.orderUpdated = true;
          this.actionOrder = { ...response.data.order }; // Ensure reactivity
          toast.success('Your spot is added to Million XRP Wall!', { icon: false });
        }

        if (response.data.level === 'warning') {
          this.paymentNotSigned = false;
          this.waitingForPut = false;
          response.data.messages.forEach(msg => {
            toast.warning(msg, { icon: false });
          });
        } else if (response.data.level === 'error') {
          this.paymentNotSigned = false;
          this.waitingForPut = false;
          this.orderUpdated = false;
          response.data.messages.forEach(msg => {
            toast.error(msg, { icon: false });
          });
        }

        this.fetchMyOrders();

      } catch (error) {
        // Handle error
        this.paymentNotSigned = true;
        this.waitingForPut = false;
        this.orderUpdated = false;
        this.letsEditOrder = false;
        toast.error('There was a problem saving your order.\nCheck your profile or contact us.', { icon: false });
        console.error('Error adding order:', error);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label,
.value {
  padding-right: 1rem;
}

.label {
  color: gray;
}

table,
.img-wrapper img {
  height: 200px;
}

.row {
  height: 15%;
}

.img-wrapper {
  max-width: 45%;
}

.img-wrapper img {
  width: 100%;
  object-fit: contain;
}

.editModal > h1 , h2 {
  color: #3185fc;
}

.mobile {
  display: none;
}



@media (max-width: 780px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  table {
    width: 100%;
    margin-left: 0;
  }

  .edit-btn-wrapper,
  .img-wrapper {
    width: 45%;
  }

  .img-wrapper img {
    width: fit-content;
    float: left;
  }

  .edit-btn-wrapper {
    display: flex;
  }

  .edit-btn-wrapper button {
    float: right;
    min-width: 90%;
  }

  .img-wrapper {
    margin-right: 10%;
  }

  .edit-btn-wrapper {
    flex-direction: column;
    align-items: end;
  }

  .img-btn-wrapper {
    display: flex;
    justify-content: space-between;
  }
}
</style>
